import httpRequest from 'httpRequest'
import {
    LocationIntegrationContract,
    OnlineIntegrationLocationContract,
    OnlineOrderIntegrationConfigurationContract,
} from 'models'
import { IntegrationContract } from 'models/IntegrationContract'
import { IntegrationsType } from 'constant/integrations'

const integrationService = {
    getAllIntegrations(type: IntegrationsType) {
        return httpRequest.get<IntegrationContract[]>(`/global/integrations`, {
            params: { type },
        })
    },
    getIntegration(id: number) {
        return httpRequest.get<IntegrationContract>(
            `/global/integrations/${id}`,
        )
    },
    getLocationIntegrations() {
        return httpRequest.get<LocationIntegrationContract[]>(
            '/integrations',
            {},
        )
    },
    getLocationIntegration(id: number) {
        return httpRequest.get<LocationIntegrationContract>(
            `/integrations/${id}`,
            {},
        )
    },
    getLocationOrderIntegrations() {
        return httpRequest.get<LocationIntegrationContract[]>(
            `/integrations`,
            {},
        )
    },
    addIntegration(id: number, settings: any) {
        return httpRequest.post(`/integrations/${id}`, settings)
    },
    updateIntegration(id: number, settings: any) {
        return httpRequest.put(`/integrations/${id}`, settings)
    },
    updateOrderChannelIntegration(
        id: number,
        settings: OnlineOrderIntegrationConfigurationContract,
    ) {
        return httpRequest.put(`/integrations/online-locations/${id}`, settings)
    },
    deleteIntegration(id: number) {
        return httpRequest.delete(`/integrations/${id}`)
    },
    syncToHubRise() {
        return httpRequest.get('/integrations/sync/hubrise')
    },
    syncToDeliverect() {
        return httpRequest.get('/integrations/sync/deliverect')
    },
    syncToMenuLive() {
        return httpRequest.get('/integrations/sync/menulive')
    },
    getOnlineLocations(integrationId: number) {
        return httpRequest.get<OnlineIntegrationLocationContract[]>(
            '/integrations/online-locations/' + integrationId,
        )
    },
    getOOIUrl() {
        return httpRequest.get<string>('/integrations/ooi-url')
    },
    getMenuLiveUrl() {
        return httpRequest.get<string>('/integrations/menulive-url')
    },
    getMenuLiveAuthorizeCode() {
        return httpRequest.post<string>('/integrations/menulive/auth')
    },
    checkUsingOnlineOrderIntegration() {
        return httpRequest.get<boolean>(
            '/integrations/use-online-order-integration',
        )
    },
    connectToMenuLive(menuLiveStoreId: string, storeApiKey: string) {
        return httpRequest.post('/integrations/menulive/connect', {
            menuLiveStoreId,
            storeApiKey,
        })
    },
    clearUnusedOrderIntegrations() {
        return httpRequest.patch(
            '/integrations/clear-unused-order-integrations',
        )
    },
}

export default integrationService
